import React, { useEffect } from 'react';
import './App.css';
import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import GeneralProvider from 'context/GeneralContext';
import Routes from './Routes.js';
import theme from 'styles/theme';
import packageJson from '../package.json';
import localStorageNames from 'data/localStorageNames';
import { getDB, replicationMiniappReq, replicationStoreLog} from 'InitiateRxdb';
import { useClientState } from 'state/useClientState';
import useClientAmplify from 'hooks/useClientAmplify';
import { useTokenCredentials } from 'state/useTokenCredentials';

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  let kiosk = urlParams.get('kiosk');

  const clearAllStorage = () => {
    Object.values(localStorageNames).forEach(key => {
      localStorage.removeItem(key);
    });
    localStorage.removeItem('reload_page');
  };

  if(kiosk === null || kiosk === 'null'){
    kiosk = '0';
    if (localStorage.getItem(localStorageNames.KIOSK) === '1'){
      kiosk = localStorage.getItem(localStorageNames.KIOSK)
    }
  }

  if (urlParams.toString()) {
    clearAllStorage();
  }

  const check = Boolean(localStorage.getItem('reload_page'));
  const getOutlet = JSON.parse(localStorage.getItem(localStorageNames.OUTLET));
  const { getClient, updateClient } = useClientState((state) => ({
    getClient: state.getClient,
    updateClient: state.updateClient,
  }));

  const [clientAmplify] = useClientAmplify();
  const { getTokenCredentials } = useTokenCredentials((state) => ({
    getTokenCredentials: state.getTokenCredentials,
  }));

  useEffect(() => {
    if (process.env.REACT_APP_ENV !== 'PRODUCTION') {
      document.title = `${process.env.REACT_APP_ENV} - ${document.title}`;
      console.log(`environment : ${process.env.REACT_APP_ENV}`);
      console.log(
        `cdn path : ${
          process.env[`REACT_APP_CDN_URL_${process.env.REACT_APP_ENV}`]
        }`,
      );
      console.log(`version code : ${packageJson.version}`);
    }
  }, []);

  useEffect(() => {
    const checkDb = async () => {
      
      if (!getClient().graphql && getTokenCredentials().access_token) {
        const client = clientAmplify(getTokenCredentials().access_token)
        updateClient(client);
        const rxdb = await getDB();
        replicationStoreLog(rxdb, getOutlet?.outletId, client);
        replicationMiniappReq(rxdb, getOutlet?.outletId, client);
      }
    };

    if (check) {
      checkDb();
    }

    window.onbeforeunload = function () {
      console.log('reload---------');
      localStorage.setItem('reload_page', true);
    };

    setTimeout(() => {
      localStorage.setItem('reload_page', false);
    }, 2000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [check]);

  return (
    <div className="App" style={{maxWidth: kiosk !== '1' && theme.containerWidth, margin: 'auto'}}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <GeneralProvider>
            <Routes />
          </GeneralProvider>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
